import { useMediaQuery } from 'react-responsive';
import { useResponsivePadding, VerticalLayout } from '../../common/common-layout';

const TermsSection1 = () => {
  const { horizontal: padding } = useResponsivePadding();
  const isMobile = useMediaQuery({ maxWidth: 1439 });

  return (
    <VerticalLayout paddingLeft={padding} paddingRight={padding} style={{ background: 'white', width: '100%', height: isMobile ? '100px' : '180px' }}>
      
    </VerticalLayout>
  );
};

export default TermsSection1;
